import { Component } from '@angular/core';
import {
	AlertComponent,
	ModalSize,
	RoutedModalBaseComponent,
	SlottedModalComponent,
	SvgIconComponent,
} from '@woolworthsnz/styleguide';
import { AsyncPipe } from '@angular/common';

@Component({
	selector: 'wnz-dual-offer-modal',
	templateUrl: './dual-offer-modal.component.html',
	styleUrls: ['./dual-offer-modal.component.scss'],
	standalone: true,
	imports: [SlottedModalComponent, SvgIconComponent, AsyncPipe, AlertComponent],
})
export class DualOfferModalComponent extends RoutedModalBaseComponent {
	size = ModalSize.Medium;
	noticeTitle = '<b>Some eLocker orders may need to be collected in store</b>';
	noticeDescription = `We’ll send you a text message if this happens. This might be because your order includes hot roast chicken or bulky items.`;
}
